import { render, staticRenderFns } from "./PtsiFooter.vue?vue&type=template&id=7706a160&scoped=true"
var script = {}
import style0 from "./PtsiFooter.vue?vue&type=style&index=0&id=7706a160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7706a160",
  null
  
)

export default component.exports